import { render, staticRenderFns } from "./BussinesCardDeck.vue?vue&type=template&id=6a9e3f5d&"
import script from "./bussines-card-deck.ts?vue&type=script&script=true&lang=ts&"
export * from "./bussines-card-deck.ts?vue&type=script&script=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports